import React from "react";
import styled from "styled-components";
import RcSlider from "rc-slider";
import "rc-slider/assets/index.css";

const SlidersWrapper = styled.div`
  height: 100px;
  font-weight: 600;
  padding: 0 40px;

  // overwrite rcslide styling - start
  .rc-slider {
    margin-top: 14px;
    &-rail {
      background-color: #000;
      height: 1px;
      margin-top: 1px;
    }
    &-track {
      display: none;
    }
    &-handle {
      background-color: #000;
      border: solid 1px #000;
      margin-top: -5px;
      width: 13px;
      height: 13px;

      &:active,
      &:focus {
        background-color: #fff;
        box-shadow: none;
      }
    }
    &-dot {
      background-color: #000;
      border: none;
      bottom: 0px;
      height: 5px
      margin-left: 0;
      width: 5px;
    }
    &-mark {
      user-select: none;

      &-text {
        border-radius: 2px;
        color: black;
        transform: translate(-2px, 7px) rotate(-50deg);
        width: 36px !important;
        
        &-active {
          &:nth-child(${props => props.activeIndex + 1}) {
            background-color: black !important;
            color: white;
            font-weight: 300;
          }
        }
      }
    }
  }
  // overwrite rcslide styling - end
`;

const SilderLabelName = styled.span`
  margin-right: 8px;
`;

class Slider extends React.Component {
  handleSlider = (value, index) => {
    this.props.sliderCallback(value, index);
  };
  render() {
    const marks = {
      2010: "2010",
      2020: "2020",
      2030: "2030",
      2040: "2040",
      2050: "2050",
      2060: "2060",
      2070: "2070",
      2080: "2080",
      2090: "2090",
      2100: "2100"
    };

    const activeIndex = Object.keys(marks).findIndex(
      key => key === this.props.value.toString()
    );

    return (
      <SlidersWrapper activeIndex={activeIndex}>
        <SilderLabelName>{this.props.label}</SilderLabelName>
        <RcSlider
          min={this.props.min}
          max={this.props.max}
          value={this.props.value}
          onChange={value => this.handleSlider(value)}
          step={this.props.step}
          dots={this.props.dots}
          marks={marks}
        />
      </SlidersWrapper>
    );
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Slider.js